/** 基础组件的特殊尺寸单独定义，所有 token 名称不要重复 */

const baseSizeToken = {
    spacingXxs: 0,
    spacingXs: '2px',
    spacingSm: '4px',
    spacingBase: '8px',
    // UI 说这个变量和 spacingMd 一样
    // spacingMinorBase: '16px',
    spacingMd: '16px',
    spacingLg: '20px',
    spacingXl1: '24px',
    spacingXl3: '32px',
    spacingXl4: '40px',
    spacingXl6: '56px',

    letterSpacingBase: '4px',

    radiusXs: 0,
    radiusSm: '4px',
    radiusBase: '8px',
    radiusMd: '16px',

    fontSizeXs: '11px',
    fontSizeSm: '13px',
    fontSizeBase: '15px',
    fontSizeMd: '17px',
    fontSizeXl1: '24px',

    lineHeightXs: '16px',
    lineHeightSm: '18px',
    lineHeightBase: '22px',
    lineHeightMd: '26px',
    lineHeightXl1: '32px'
};

/**
 * 通用布局变量
 * 1. padding 或者 margin 上下分别定义，block 代表上下，inline 代表左右
 */
const layoutSizeToken = {
    /* 页面整体的上下 padding */
    layoutPagePaddingBlock: baseSizeToken.spacingMd,
    /* 页面整体的上下 padding */
    layoutPagePaddingInline: baseSizeToken.spacingMd,

    /* 布局左侧页面路由配置为「 hasPadding: true 」时， 页面有 padding */
    layoutContentPaddingBlock: baseSizeToken.spacingLg,
    layoutContentPaddingInline: baseSizeToken.spacingLg
};

module.exports = {
    sizeToken: {
        ...baseSizeToken,
        ...layoutSizeToken
    }
};
